import React, { Component } from "react";
import { InputFactory, dialog } from "nq-component";
import BaseListPage from "../../../../../../../base/BaseListPage";
import Presenter from "../../../../../../HumanResource/Employees/forms/DropdownTable/Presenter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../../usecases/object";

export default class Deduction extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new Presenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      description: "",
      amount: "",
    };
  }

  getCollectionName() {
    return "deduction";
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onChangeDescription(description) {
    this.setState({ description });
  }
  onChangeAmount(amount) {
    this.setState({ amount });
  }

  async handleSaveButton() {
    if (this.state.description === "") {
      this.showError("Description is required");
    } else if (this.state.amount === "") {
      this.showError("Amount is required");
    } else {
      const data = {
        description: this.state.description,
        amount: this.state.amount,
      };
      // await this.presenter.upsertUseCase.execute("deduction", data);
      this.props.Deduction(data);
      dialog.close();
    }
  }

  render() {
    return (
      <div>
        <h4>New Deductions</h4>
        <hr />
        <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
          Description <span style={{ color: "red" }}>*</span>
        </label>
        <InputFactory
          type="String"
          field="description"
          onChange={this.onChangeDescription.bind(this)}
        />
        <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
          Amount
        </label>
        <InputFactory
          type="Number"
          field="amount"
          onChange={this.onChangeAmount.bind(this)}
        />
        <div className="mt-4 mb-4 d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-light fs-sm me-3"
            onClick={() => dialog.close()}
          >
            Cancel
          </button>
          <button
            onClick={this.handleSaveButton.bind(this)}
            className="btn btn-primary fs-sm me-3"
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}
